export const getLocalstorageValue = (keyValue: string) => JSON.parse(localStorage.getItem(keyValue) as string)